import { useChegadasViagensStore } from "../../stores/useChegadasViagensStore";
import { useChegadasRoom } from "./useChegadasRoom";
import { useEnsureChegadas } from "./useEnsureChegadas";

const EMPTY = [];

export function useChegadas(codigo) {

    useChegadasRoom(codigo);
    useEnsureChegadas(codigo);

    return useChegadasViagensStore(state => {

        const key = String(codigo || '').trim();

        return state.chegadas[key] ?? EMPTY;

    });

}